import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {UTM} from '../../models/utm';

@Injectable({providedIn: 'root'})
export class UTMService {

  private _currentUTMSubject: BehaviorSubject<UTM>;
  public currentUTM: Observable<UTM>;

  constructor() {
    this._currentUTMSubject = new BehaviorSubject<UTM>(new UTM());
    this.currentUTM = this._currentUTMSubject.asObservable();
  }

  public get currentUTMValue(): UTM {
    return this._currentUTMSubject.value;
  }

  public set setCampaign(value) {
    const utm = this.currentUTMValue;
    utm.utm_campaign = value;
    this.currentUTMSubject = (utm);
  }

  public set setMedium(value) {
    const utm = this.currentUTMValue;
    utm.utm_medium = value;
    this.currentUTMSubject = (utm);
  }


  public set setSource(value) {
    const utm = this.currentUTMValue;
    utm.utm_source = value;
    this.currentUTMSubject = (utm);
  }


  public set setContent(value) {
    const utm = this.currentUTMValue;
    utm.utm_content = value;
    this.currentUTMSubject = (utm);
  }

  set currentUTMSubject(value) {
    this._currentUTMSubject.next(value);
  }
}
